import { PeopleEmployeePersonalDetailsDto } from "./employee/people-employee-personal-details.dto";
import { PeopleEmployeeVisaDto } from "./employee/people-employee-visa.dto";
import { PeopleQueryBaseDto } from "./people-query-base.dto";

export class PeopleCountryDto {
    id: number;
    name: string;
    code: string;
    callingCode?: string;
    requireVisa?: boolean;

    employeeVisas?: PeopleEmployeeVisaDto[];
    employeePersonalDetails?: PeopleEmployeePersonalDetailsDto[];
}

export interface PeopleCountryQueryDto extends PeopleQueryBaseDto {
    name?: string;
}